import {toggle} from 'opticks/lib/optimizely'
import Settings from 'Settings'
import {urlParams} from 'utils/urlParams'

const STRIPE_PROVIDER_CODE = 'GAR'

const ASSISTED_BOOKING_BOFH_API_KEY = Settings.get(
  'REACT_APP_BOFH_PROFILE_KEY_ASSISTED_BOOKING'
)
const ASSISTED_BOOKING_WITH_POST_STAY_NPS_BOFH_API_KEY = Settings.get(
  'REACT_APP_BOFH_PROFILE_KEY_ASSISTED_BOOKING_WITH_POST_STAY_NPS'
)

const MOR_BOFH_API_KEY = Settings.get('REACT_APP_BOFH_PROFILE_KEY_MOR')

const MOR_WITH_POST_STAY_NPS_BOFH_API_KEY = Settings.get(
  'REACT_APP_BOFH_PROFILE_KEY_MOR_WITH_POST_STAY_NPS'
)

export const DEFAULT_BOFH_API_KEY = ASSISTED_BOOKING_BOFH_API_KEY

// Allows you to force a profile key for test
const {profile = null} = urlParams()

const isStripe = (providerCode: string) => providerCode === STRIPE_PROVIDER_CODE

export const determinePreBookingSubmitApiKey = () => {
  if (profile) return profile

  return DEFAULT_BOFH_API_KEY
}

export const determineBookingApiKey = (providerCode: string) => {
  if (profile) return profile

  const postStayNpsAbActive = toggle(
    '0c180a39-post-stay-nps-survey',
    false,
    true
  )

  if (isStripe(providerCode)) {
    return postStayNpsAbActive
      ? MOR_WITH_POST_STAY_NPS_BOFH_API_KEY
      : MOR_BOFH_API_KEY
  }

  return postStayNpsAbActive
    ? ASSISTED_BOOKING_WITH_POST_STAY_NPS_BOFH_API_KEY
    : ASSISTED_BOOKING_BOFH_API_KEY
}
